<div class="cart-box-content">
  <div class="centeret">
    <span class="box-title" i18n>Tilføjet til kurven</span>
    <br>
    <button (click)="buyMore.emit()" class="button-primary" i18n>Køb mere</button>
    @if (notOnCartPage()) {
      <button (click)="goToCheckout()" class="btn btn-light" i18n>Gå til indkøbskurv</button>
    }
  </div>
</div>
